
import React, { PureComponent } from 'react'
import { reduxForm } from 'redux-form'
import { Col, Table, Button, Tooltip, OverlayTrigger } from 'react-bootstrap'
import IDocCarPagination from '../../../commons/iDocCarPagination'
import ProcessingAgencyIntegrationRegistrationTypesMasterModalPage from '../../../../containers/masters/ProcessingAgency/processingAgencyIntegrations/ProcessingAgencyIntegrationRegistrationTypesMasterModalPage'

class ProcessingAgencyIntegrationRegistrationTypesMaster extends PureComponent {
  constructor () {
    super()
    this.state = {
      initialized: false,
      filter: {
      }
    }
  }

  getSortIcon (column = '') {
    switch (this.props.filter.orderBy) {
      case '+' + column:
        return 'ico-sort-selected-asc'
      case '-' + column:
        return 'ico-sort-selected-desc'
      default:
        return 'ico-sort'
    }
  }

  componentDidMount () {
    this.props.actions.fetchProcessingAgencyRegistrationTypesList(this.props.agency.processingAgencyId, { ...this.state.filter, ...this.props.filter })
    this.props.actions.fetchOperationTypeAll()
  }

  changeOrder (field) {
    switch (this.props.filter.orderBy) {
      case `+${field}`:
        this.props.actions.fetchProcessingAgencyRegistrationTypesList(this.props.agency.processingAgencyId, { ...this.state.filter, ...this.props.filter, orderBy: `-${field}` })
        break
      default:
        this.props.actions.fetchProcessingAgencyRegistrationTypesList(this.props.agency.processingAgencyId, { ...this.state.filter, ...this.props.filter, orderBy: `+${field}` })
        break
    }
  }

  render () {
    const {
      t, processingAgencyRegistrationTypes, pagesCount, filter, processingAgencyRegistrationTypesCount,
      filter: { page },
      actions: { showProcessingAgencyRegistrationTypesModal }
    } = this.props
    const tKey = 'MASTERS.PROCESSING_AGENCY_MASTERS.REGISTRATION_TYPES.'
    const editTooltip = (<Tooltip id="editTooltip">{t(`${tKey}EDIT`)}</Tooltip>)
    const deleteTooltip = (<Tooltip id="deleteTooltip">{t(`${tKey}DELETE`)}</Tooltip>)
    return (
      <Col id="processingAgencyIntegrationRegistrationTypesMaster" className="admin-wrapper masters-process-agency-padding">
        <ProcessingAgencyIntegrationRegistrationTypesMasterModalPage />
        <Table className="editable-table" hover responsive>
          <thead>
            <tr>
              <th onClick={() => { this.changeOrder('dossierOperationTypeLocale') }}>
                {t(`${tKey}OPERATION_TYPE`)}
                <i className={this.getSortIcon('dossierOperationTypeLocale')} />
              </th>
              <th onClick={() => { this.changeOrder('registrationTypeId') }}>
                {t(`${tKey}REGISTRATION_TYPE`)}
                <i className={this.getSortIcon('registrationTypeId')} />
              </th>
              <th className='actions'>{t('DOSSIER_COMPONENTS.ACCESSORIES.ACTIONS')}</th>
            </tr>
          </thead>
          <tbody>
            {processingAgencyRegistrationTypes && processingAgencyRegistrationTypes.map((processingAgencyRegistrationType, idx) => {
              return (
                <tr key={idx} className={processingAgencyRegistrationType.isDeleted ? 'is-deleted' : ''}>
                  <td>{processingAgencyRegistrationType.dossierOperationTypeLocale}</td>
                  <td>{processingAgencyRegistrationType.registrationTypeId}</td>
                  <td className='actions'>
                    {!processingAgencyRegistrationType.isDeleted && (
                      <div>
                        <OverlayTrigger placement="left" overlay={editTooltip}>
                          <a className='_Btn accept stk o-icn ' onClick={() => showProcessingAgencyRegistrationTypesModal(this.props.agency.processingAgencyId, true, processingAgencyRegistrationType)}>
                            <i className="iDocIcon-edit" />
                          </a>
                        </OverlayTrigger>
                        <OverlayTrigger placement="left" overlay={deleteTooltip}>
                          <a className='_Btn cancel stk o-icn ' onClick={() => this.props.actions.deleteProcessingAgencyRegistrationTypes(this.props.agency.processingAgencyId, processingAgencyRegistrationType.processingAgencyRegistrationTypeId)}>
                            <i className="iDocIcon-delete-forever" />
                          </a>
                        </OverlayTrigger>
                      </div>
                    )}
                  </td>
                </tr>)
            })
            }
            {(processingAgencyRegistrationTypes === null || processingAgencyRegistrationTypes === undefined || processingAgencyRegistrationTypes.length === 0) &&
          <tr>
            <td colSpan={10}><h2>{t(`${tKey}RESULTS_NOT_FOUND`)}</h2></td>
          </tr>}
            <tr className="button-table-wrapper">
              <td>
                <Button
                  className="_Btn new"
                  onClick={() => showProcessingAgencyRegistrationTypesModal(this.props.agency.processingAgencyId, true)}
                >
                  {t(`${tKey}ADD`)}
                </Button>
              </td>
            </tr>
          </tbody>
        </Table>
        <div className="section-users-footer">
          <nav key={1} className="text-center">
            <IDocCarPagination
              id="btn_pag_sales"
              page={page}
              pagesCount={pagesCount}
              totalRows={processingAgencyRegistrationTypesCount}
              onSelectAction={(value) => this.props.actions.fetchProcessingAgencyRegistrationTypesList(this.props.agency.processingAgencyId, { ...filter, ...this.state.filter, page: value })}
            />
          </nav>
        </div>
      </Col>
    )
  }
}

export default reduxForm({
  form: 'editProcessingAgencyIntegrationRegistrationTypesMaster',
  validate: (values, props) => {
  }
})(ProcessingAgencyIntegrationRegistrationTypesMaster)
